import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { AboutComponent } from './components/about/about.component';
import { SolutionsComponent } from './components/solutions/solutions.component';
import { ConsultingComponent } from './components/solutions/consulting/consulting.component';
import { ProductsComponent } from './components/solutions/products/products.component';
import { DcsAmlComponent } from './components/solutions/products/dcs-aml/dcs-aml.component';
import { MetricstreamComponent } from './components/solutions/products/metricstream/metricstream.component';
import { OutsourcingComponent } from './components/solutions/outsourcing/outsourcing.component';
import { PeopleComponent } from './components/people/people.component';
import { SpontaneousComponent } from './components/people/spontaneous/spontaneous.component';
import { InsideComponent } from './components/inside/inside.component';
import { ContactsComponent } from './components/contacts/contacts.component';
import { EmploymentOpportunitiesComponent } from './components/people/employment-opportunities/employment-opportunities.component';
import { PostsComponent } from './components/inside/posts/posts.component';
import { LanguageComponent } from './components/language/language.component';
import {PageNotFoundComponent} from './components/page-not-found/page-not-found.component';

const routes: Routes = [
  { path: '', component: HomeComponent }, // Root now shows HomeComponent

  { path: 'about', component: AboutComponent },

  /*{
    path: 'solutions',
    children: [
      { path: 'consulting', component: ConsultingComponent },
      {
        path: 'products',
        component: ProductsComponent,
        children: [
          { path: 'dcs-aml-framework', component: DcsAmlComponent },
          { path: 'metricstream', component: MetricstreamComponent },
        ]
      },
      { path: 'outsourcing-nearshore', component: OutsourcingComponent },
      { path: '', component: SolutionsComponent }
    ]
  },*/

  /*{
    path: 'people',
    children: [
      { path: 'employment-opportunities/:jobId', component: EmploymentOpportunitiesComponent },
      { path: 'spontaneous-application', component: SpontaneousComponent },
      { path: '', component: PeopleComponent }
    ]
  },*/

  {
    path: 'blog',
    children: [
      { path: ':postId', component: PostsComponent },
      { path: '', component: InsideComponent }
    ]
  },

  { path: 'contact', component: ContactsComponent },

  // 404 catch-all
  { path: '**', component: PageNotFoundComponent }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
